import { useStaticQuery, graphql } from 'gatsby';

const useNominationForm = () => {
  const { datoCmsWebsiteForm } = useStaticQuery(NominationFormQuery);

  return { datoCmsWebsiteForm };
};

export default useNominationForm;

const NominationFormQuery = graphql`
  query NominationFormFormQuery {
    datoCmsWebsiteForm(
      id: { eq: "DatoCmsWebsiteForm-SPH_vBBoT0uE4jcv1Adx3Q" }
    ) {
      id
      heading
      subhead
      callToAction
      pardotFormHandler
    }
  }
`;
